<template>
  <div class="flex w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 min-w-card">
    <div class="card card-bio-content card--interactive text-center">
      <h6
        class="text-blue uppercase -mt-2 mb-4"
        v-text="membershipGroup.attributes.type"
      />
      <h2
        class="mb-1"
        v-text="membershipGroup.attributes.title"
      />
      <h5
        v-if="membershipGroup.attributes.membership_count !== undefined"
        class="mt-0 mb-4 uppercase"
        v-text="count"
      />
      <button
        v-if="showRemoveAction"
        type="button"
        class="btn btn--border btn--sm btn--danger"
        @click.prevent="$emit('removeFromMembershipGroup', membershipGroup)"
        v-text="'Remove from group'"
      />
    </div>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'MembershipGroup',
  props: {
    membershipGroup: {
      type: Object,
      required: true,
    },
    showRemoveAction: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    count() {
      return this.membershipGroup.attributes.membership_count === 1
        ? '1 member'
        : `${this.membershipGroup.attributes.membership_count} members`
    },
  },
}
</script>
